export default __webpack_public_path__ + "static/media/Vicara.bca19eeb.png";